import React, { useState, useEffect } from 'react';
import config from '../../../config';
import TreeNode from './treeNode';

const calculateTreeData = edges => {
  const originalData = config.sidebar.ignoreIndex
    ? edges.filter(
        ({
          node: {
            fields: { slug },
          },
        }) => slug !== '/'
      )
    : edges;

  const tree = originalData.reduce(
    (
      accu,
      {
        node: {
          fields: { slug, title },
        },
      }
    ) => {
      const parts = slug.split('/');

      let { items: prevItems } = accu;

      const slicedParts =
        config.gatsby && config.gatsby.trailingSlash ? parts.slice(1, -2) : parts.slice(1, -1);

      for (const part of slicedParts) {
        let tmp = prevItems && prevItems.find(({ label }) => label == part);

        if (tmp) {
          if (!tmp.items) {
            tmp.items = [];
          }
        } else {
          tmp = { label: part, items: [] };
          prevItems.push(tmp);
        }
        prevItems = tmp.items;
      }
      const slicedLength =
        config.gatsby && config.gatsby.trailingSlash ? parts.length - 2 : parts.length - 1;

      const existingItem = prevItems.find(({ label }) => label === parts[slicedLength]);

      if (existingItem) {
        existingItem.url = slug;
        existingItem.title = title;
      } else {
        prevItems.push({
          label: parts[slicedLength],
          url: slug,
          items: [],
          title,
        });
      }
      return accu;
    },
    { items: [] }
  );

  const {
    sidebar: { forcedNavOrder = [] },
  } = config;

  const tmp = [...forcedNavOrder];

  if (config.gatsby && config.gatsby.trailingSlash) {
  }
  tmp.reverse();
  const sortItems = items => {
    items.sort(function(a, b) {
      if (a.label < b.label) return -1;
      if (a.label > b.label) return 1;
      return 0;
    });
    items.forEach(item => {
      if (item.items) {
        sortItems(item.items);
      }
    });
  };
  sortItems(tree.items);

  return tmp.reduce((accu, slug) => {
    const parts = slug.split('/');

    let { items: prevItems } = accu;

    const slicedParts =
      config.gatsby && config.gatsby.trailingSlash ? parts.slice(1, -2) : parts.slice(1, -1);

    for (const part of slicedParts) {
      let tmp = prevItems.find(item => item && item.label == part);

      if (tmp) {
        if (!tmp.items) {
          tmp.items = [];
        }
      } else {
        tmp = { label: part, items: [] };
        prevItems.push(tmp);
      }
      if (tmp && tmp.items) {
        prevItems = tmp.items;
      }
    }
    // sort items alphabetically.
    prevItems.map(item => {
      item.items = item.items.sort(function(a, b) {
        if (a.label < b.label) return -1;
        if (a.label > b.label) return 1;
        return 0;
      });
    });
    const slicedLength =
      config.gatsby && config.gatsby.trailingSlash ? parts.length - 2 : parts.length - 1;

    const index = prevItems.findIndex(({ label }) => label === parts[slicedLength]);

    if (prevItems.length) {
      accu.items.unshift(prevItems.splice(index, 1)[0]);
    }
    return accu;
  }, tree);
};

const Tree = ({ edges, location, onNavigate }) => {
  let [treeData] = useState(() => {
    return calculateTreeData(edges);
  });

  // Get current path to determine which items should be expanded
  const getCurrentPath = () => {
    if (location && location.pathname) {
      return location.pathname;
    } else if (typeof window !== 'undefined' && window.location) {
      return window.location.pathname;
    }
    return '';
  };

  const defaultCollapsed = {};
  const currentPath = getCurrentPath();

  treeData.items.forEach(item => {
    // Check if this item should be collapsed based on config
    const shouldCollapse = config.sidebar.collapsedNav && config.sidebar.collapsedNav.includes(item.url);

    // Expand all menus by default, only collapse if explicitly set in config
    defaultCollapsed[item.url] = shouldCollapse ? true : false;
  });

  const [collapsed, setCollapsed] = useState(defaultCollapsed);

  // Update collapsed state when location changes
  useEffect(() => {
    const currentPath = getCurrentPath();
    const newCollapsed = {};

    treeData.items.forEach(item => {
      const shouldCollapse = config.sidebar.collapsedNav && config.sidebar.collapsedNav.includes(item.url);
      // Expand all menus by default, only collapse if explicitly set in config
      newCollapsed[item.url] = shouldCollapse ? true : false;
    });

    setCollapsed(newCollapsed);
  }, [location]);

  const toggle = url => {
    setCollapsed({
      ...collapsed,
      [url]: !collapsed[url],
    });
  };

  return (
    <TreeNode
      className={`${config.sidebar.frontLine ? 'showFrontLine' : 'hideFrontLine'} firstLevel`}
      setCollapsed={toggle}
      collapsed={collapsed}
      location={location}
      onNavigate={onNavigate}
      {...treeData}
    />
  );
};

export default Tree;
